import { render, staticRenderFns } from "./BackgroundCivilCourtProceedings.vue?vue&type=template&id=4981c654&scoped=true"
import script from "./BackgroundCivilCourtProceedings.vue?vue&type=script&lang=ts"
export * from "./BackgroundCivilCourtProceedings.vue?vue&type=script&lang=ts"
import style0 from "./BackgroundCivilCourtProceedings.vue?vue&type=style&index=0&id=4981c654&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4981c654",
  null
  
)

export default component.exports